import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  button: {
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
  },
  text: {
    color: "#FFF",
    fontSize: 18,
    fontWeight: "500",
  },
});
